const _ = require('lodash');

class RichRelevanceProductsController {
    constructor(richRelevanceService, shelfProductService, settingsService, breakpointsService) {
        this.products = [];
        this.title = '';
        this.richRelevanceService = richRelevanceService;
        this.shelfProductService = shelfProductService;
        this.settingsService = settingsService;
        this.breakpointsService = breakpointsService;

        if (_.isNil(this.showTitle)) {
            // by default we show the title
            this.showTitle = true;
        }
    }
    refreshProducts() {
        // this.placementId is from the directive attribute
        this.richRelevanceService.registerPlacementCallback(this.richRelevanceService.getEffectivePlacementId(this.placementId), (placements) => {

            if (!placements) {
                this.products = null;
                this.title = null;
                return;
            }

            this.title = placements.message;

            this.shelfProductService.getProductsByStockcodes(_.map(placements.items, 'id'), true)
                .then((wowProducts) => {
                    this.products = wowProducts;
                    if (this.onProductsLoaded) {
                        this.onProductsLoaded();
                    }
                });
        });
    }
    $onInit() {
        this.refreshProducts();
    }
}


const richRelevanceProductsComponentDefinition = {
    bindings: {
        placementId: '@', // defines which placement ID the controller should use to get RR products.
        showTitle: '=', // provide a true, when the directive displays RR title.
        onProductsLoaded: '&', // call back method for after product load.
    },
    controller: ['RichRelevanceService', 'ShelfProductService', 'SettingsService', 'BreakpointsService', RichRelevanceProductsController],
    controllerAs: 'richRelevanceProductsCtrl',
    template: require('./rr-products.component.html').trim(),
};

module.exports = {
    RichRelevanceProductsController,
    richRelevanceProductsComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/richrelevance/rr-products.component.js